let FeatureConstants = /** @class */ (() => {
    class FeatureConstants {
    }
    FeatureConstants.Features = class {
        static ClockWork() {
            return "C35FB00A-6960-4169-99AF-0DF0177B8826";
        }
        static Experimental() {
            return "C0FD1095-F44F-4A4A-9517-231307CCCB55";
        }
        static PMO() {
            return "54CE662C-F10A-452F-BB5D-5141A4AB5ECE";
        }
        static Permea() {
            return "21B58656-ADA6-4622-97C1-591CC8A9BD7D";
        }
        static PrayTube() {
            return "52D58157-3983-420D-BDB6-5A4E05DEF28E";
        }
        static CRM() {
            return "E67D0655-7734-4CA2-B8EE-83A745D5AFA1";
        }
        static Asset() {
            return "E038D629-329B-4420-A4A5-902AC3052E7F";
        }
    };
    return FeatureConstants;
})();
export { FeatureConstants };
